module.exports = __webpack_public_path__ + "img/servinsa.5cd5f60f.png";